// Pure, dependency-free participant-color assignment logic.
// Kept separate from `theme.ts` so it can be unit-tested without
// pulling in DOM/preact/CSS imports.

export const createParticipantColorAssigner = (paletteSize: number) => {
  const cache = new Map<string, number>();
  let nextIndex = 0;
  return {
    getIndex: (name: string): number => {
      const existing = cache.get(name);
      if (existing !== undefined) return existing;
      const idx = nextIndex % paletteSize;
      cache.set(name, idx);
      nextIndex++;
      return idx;
    },
    reset: () => {
      cache.clear();
      nextIndex = 0;
    },
  };
};
